export enum DocumentType {
  MembershipCard = "membershipCardUrl",
  Receipt = "receiptCopyUrl",
  Policy = "policyCopyUrl",
  PolicyWording ="policyWordingUrl"
}
